import { render, staticRenderFns } from "./AdditionalFieldInput.vue?vue&type=template&id=2020a035&scoped=true"
import script from "./AdditionalFieldInput.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldInput.vue?vue&type=script&lang=js"
import style0 from "./AdditionalFieldInput.vue?vue&type=style&index=0&id=2020a035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2020a035",
  null
  
)

export default component.exports